import './CookiesInfo.css';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
import { useEffect, useState } from 'react';

const CookiesInfo = ({ displayCookiesInfo, setDisplayCookiesInfo }) => {
  const [consent, setConsent] = useState(null);

  // Odczytaj ciasteczko po załadowaniu komponentu
 useEffect(() => {
  const cookie = document.cookie
    .split("; ")
    .find(row => row.startsWith("cookie_consent="));
  const value = cookie?.split("=")[1];

  setConsent(value || null);

  if (value === "accepted") {
    loadGtag();
    setDisplayCookiesInfo(false); // tylko jeśli zaakceptowano, chowamy baner
  } else if (!value) {
    setDisplayCookiesInfo(true); // pokaż baner, jeśli ciasteczka brak
  }
}, [setDisplayCookiesInfo]);

  const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
    console.log("Set-Cookie:", `${name}=${value}`);
  };

  const loadGtag = () => {
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-6RGGRRRDTQ';
    document.head.appendChild(gtagScript);

    const gtagInit = document.createElement('script');
    gtagInit.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-6RGGRRRDTQ', { anonymize_ip: true });
    `;
    document.head.appendChild(gtagInit);
  };

  const handleAccept = () => {
    setCookie('cookie_consent', 'accepted', 365);
    setDisplayCookiesInfo(false);
    loadGtag();
  };

  const handleReject = () => {
    setCookie('cookie_consent', 'rejected', 365);
    setDisplayCookiesInfo(false);
  };

  const variants = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 50 }
  };

  return displayCookiesInfo && consent !== 'accepted' && consent !== 'rejected' ? (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.7 }}
      id="MainCookiesDiv"
    >
      <Link to="/Cookies" id="CookiesPageLink">
        Polityka cookies
      </Link>

      <p className='cookiesInfoText'>Strona korzysta z plików cookies w celach niezbędnych do działania oraz — za Twoją zgodą — w celach analitycznych (Google Analytics).</p>
      <p className='cookiesInfoText'>Czy zgadzasz się na cookies analityczne (Google Analytics)?</p>

      <div style={{ marginTop: '12px' }} id='CookiesButtonsDiv'>
        <button id='hideCookiesBtn' onClick={handleAccept}>
          Akceptuję
        </button>
        <button id='hideCookiesBtn' onClick={handleReject}>
          Odrzucam
        </button>
      </div>
    </motion.div>
  ) : null;
};

export default CookiesInfo;